import { render, staticRenderFns } from "./PalletPreviewDialog.vue?vue&type=template&id=59ae73d8&scoped=true&"
import script from "./PalletPreviewDialog.vue?vue&type=script&lang=js&"
export * from "./PalletPreviewDialog.vue?vue&type=script&lang=js&"
import style0 from "./PalletPreviewDialog.vue?vue&type=style&index=0&id=59ae73d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ae73d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardText,VDialog,VIcon,VTooltip})
